<div class="c-spinner">
  <button type="button" id="{{field.id}}__spinUp" (click)="stepSpinner(true)">▲</button>
  <button type="button" id="{{field.id}}__spinDown" (click)="stepSpinner(false)">▼</button>
</div>
